import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
    headerTitle: {
        fontSize: '20px',
        fontWeight: 700,
        paddingLeft: '7px',
        paddingBottom: '7px'
    },
    searchBox: {
        padding: theme.spacing(4, 3.7, 2.5, 3.7)
    },
    sideBarSearchView: {
        display: 'flex',
        alignItems: 'center',
        justify: "space-between"
    },
    search: {
        marginLeft: "auto",
        marginBottom: "0",
        "& .MuiInputBase-root": {
            maxWidth: '100%',
            padding: 5,
            borderRadius: 30,
            border: "unset",
            position: "relative",
            marginRight: 0,
            backgroundColor: "#edf4fb",
            [theme.breakpoints.up("md")]: {
                // width: 300,
            },
        },
        "& .MuiInputBase-root::before": {
            content: "unset",
        },
        "& .MuiInputBase-root::after": {
            content: "unset",
        },
        "& .MuiFormLabel-root": {
            paddingLeft: 10,
            color: "#AEB2BA",
            position: "relative",
            zIndex: 2,
            top: 20,
            left: 10,
        },
        "& .MuiFormLabel-root.Mui-focused": {
            paddingLeft: 10,
            color: theme.palette.primary.main,
            position: "relative",
            zIndex: 2,
            top: 0,
            left: 0,
        },
        "& .MuiFormLabel-root.MuiFormLabel-filled": {
            paddingLeft: 10,
            color: theme.palette.primary.main,
            position: "relative",
            zIndex: 2,
            top: 0,
            left: 0,
        },
        "& ::placeholder": {
            opacity: 1,
            fontSize: '14px'
        },
        border: "0px solid #fff",
        borderRadius: 30,
        transition: "border 0.4s ease-in-out",
        "&:hover, &:focus": {
            boxShadow: "2px 2px 9px 2px rgba(0,0,0,0.1)",
        },
    },
    searchIcon: {
        width: '14px',
        margin: '4px'
    },
    filterIcon: {
        fontSize: 30,
        margin: '0 0 0 16px'
    },
    driverListBoxContainer: {
        display: 'flex',
        flexDirection: 'column',
        height: '100%'
    },
    driverListBox: {
        flex: '1 1 0%',
        overflow: 'auto'
    },
    driverListItem: {
        padding: theme.spacing(1.25, 3, 1.25, 3),
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'flex-start',
        borderBottom: '1px solid rgba(0,0,0,0.08)'
    },
    driverListItemSelected: {
        backgroundColor: 'rgba(255,212,40,.10)'
    },
    driverListItemIconBox: {

    },
    driverListItemIcon: {
        height: '24px',
        width: '24px',
        borderRadius: '24px',
        overflow: 'hidden',
        backgroundColor: 'grey',
        display: 'flex',
        padding: '6px',
        justifyContent: 'center',
        alignItems: 'center'
    },
    driverListItemIconMoving: {
        backgroundColor: 'rgb(141,226,100)',
    },
    driverListItemIconParked: {
        backgroundColor: 'rgb(226,120,100)',
    },
    userIconMoving: {

    },
    driverListItemSideBox: {
        flex: '1',
        padding: theme.spacing(0, 0, 0, 2.5)
    },
    driverName: {
        fontSize: '14px',
        fontWeight: 700
    },
    stateDate: {
        fontSize: '12px',
        color: 'rgb(177,177,177)',
        padding: '3px 0'
    },
    sortByMenuBox: {
    },
    sortByMenuHeader: {
        fontSsize: '12px',
        fontWeight: 500,
        padding: theme.spacing(0, 1.5, 1, 2)
    },
    sortByMenuSubHeader: {
        fontSsize: '12px',
        fontWeight: 200,
        padding: theme.spacing(0, 1.5, 0.5, 2),
        color: 'rgb(177,177,177)',
    },
    sortByMenuItem: {
        fontSize: '12px',
        display: 'flex',
        alignItems: 'center',
        padding: theme.spacing(0, 1.5, 0, 1),
    },
    sortByMenuItemRadio: {
        width: '14px',
        height: '14px',
        borderRadius: '14px',
        border: '1px solid rgb(151,151,151)'
    },
    sortByMenuItemRadioSelected: {
        border: '4px solid rgb(255,211,40)',
    },
    sortByMenuItemText: {
        lineHeight: '18px',
        padding: theme.spacing(0, 2, 0, 1)
    },
    driverLocatorSidebarLoader: {
        alignItems: 'center',
        display: 'grid',
        margin: '0 auto'
    },
    driverLocatorSidebarNoRecordText: {
        fontWeight: 500,
        color: "#242A38",
        padding: theme.spacing(0.5, 3),
        fontSize: 14,
        "& a": {
            color: "rgba(0, 0, 0, 0.87)",
            textDecoration: "unset",
        },
    }
}));
